enum Page {
  Home,
  About,
  Services,
  Portfolio,
  Blog,
  Contact
}

export default Page;